export const DOCUMENT_SCHEMA_VERSION = 2;
export const MAX_RASTER_LAYERS = 5;
export const MAX_OBJECT_LAYERS = 1;
export const MAX_TOTAL_LAYERS = 6;
export const MAX_LAYER_NAME_LENGTH = 40;
export const MAX_IMPORTED_NONBLANK_LAYER_PIXELS = 20_000_000;

// Five 1600 x 2000 current surfaces plus paired baselines are about 122 MiB.
// The remaining headroom covers one explicit merge/snapshot surface and the
// display canvas without permitting unbounded full-document allocations.
export const ESTIMATED_LAYER_MEMORY_BUDGET_BYTES = 192 * 1024 * 1024;
export const RASTER_STORE_MEMORY_BUDGET_BYTES = 96 * 1024 * 1024;

export type LayerRole = "sketch" | "ink" | "colour" | "background" | "dialogue" | "custom";

export interface PersistedLayerState {
  id: string;
  name: string;
  type: "raster" | "object";
  role: LayerRole;
  system: boolean;
  visible: boolean;
  locked: boolean;
  opacity: number;
  order: number;
}

export interface StoredRasterLayerBlob {
  layerId: string;
  mimeType: "image/png";
  blank: boolean;
  blob?: Blob;
}

export type LayerPreset = "sketch" | "ink" | "colour" | "background" | "custom";

export const LAYER_PRESETS: ReadonlyArray<{ role: LayerPreset; label: string }> = [
  { role: "sketch", label: "Sketch" },
  { role: "ink", label: "Ink" },
  { role: "colour", label: "Colour" },
  { role: "background", label: "Background" },
  { role: "custom", label: "New Layer" },
];

export function isLayerRole(value: unknown): value is LayerRole {
  return (
    value === "sketch" ||
    value === "ink" ||
    value === "colour" ||
    value === "background" ||
    value === "dialogue" ||
    value === "custom"
  );
}
